import React from 'react';
import Box from "../../../element/Box";
import Product from "../ProductForOffice";

const CatalogService = () => {
    return (
        <Box>
            <Product type={"service"}/>
        </Box>
    );
};

export default CatalogService;